import { createRoot } from "react-dom/client";
import "~/less/styles.less";
import "~/utils/debug/Logger";
import Root from "./Root";
import mbc from "~/shared/functions/mbc";

// Følgende er for å unngå 'unsafe-eval' CSP-feil
import { z } from "zod";
z.config({ jitless: true });

if (mbc.isNative()) {
	const body = document.getElementById("body");
	body?.classList.add("regard-color-scheme-preference");
}

const element = document.getElementById("ppm-portal-root");
if (!element) {
	throw new Error("No element #ppm-portal-root found");
}
const root = createRoot(element);
root.render(<Root />);
